/**
 * Example JavaScript singleton module
 */

var Header = (function($) {

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('header').outerHeight();

     // on scroll, let the interval function know the user has scrolled
  
    $(window).scroll(function(event){

        didScroll = true;
    });

    // run hasScrolled() and reset didScroll status
  
    setInterval(function() {

        if (didScroll) {
        hasScrolled();
        didScroll = false;
        }
    }, 250);

    function hasScrolled() {

        var st = $(this).scrollTop();
        if (Math.abs(lastScrollTop - st) <= delta) {
        return;
        }

        if (!$('.has-nav').length){

            // If current position > last position AND scrolled past navbar...
            if (st > lastScrollTop && st > navbarHeight){
            // Scroll Down
            
            $('header').removeClass('header--down').addClass('header--up');
            $('#cookies').removeClass('header--down').addClass('header--up');

            } else {
                // Scroll Up
                // If did not scroll past the document (possible on mac)...
                if(st + $(window).height() < $(document).height()) { 
                    $('header').removeClass('header--up').addClass('header--down');
                    $('#cookies').removeClass('header--up').addClass('header--down');
                }
            }
    
            if ($(window).scrollTop() <= 40) {
                $('header').removeClass('header--up').removeClass('header--down');
                $('#cookies').removeClass('header--up').removeClass('header--down');
            }
    
            lastScrollTop = st;
            
        }

        
    }
  
  function init() {

    // return early if no corresponding module present
    if (!$('.header').length) {
      return;
    }

    

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Header.init);
